import {
  ADD_CC,
  AUTH,
  BROWSE,
  CHOOSE_CC,
  CONFIRMATION,
  MENU,
  RESERVATION_PATH_PLACEMENT,
  SUMMARY,
} from '../../constants/bookingFlow';

// set the token as search param
export const getTokenFromBooking = (booking) => {
  if (booking?.resy_token) {
    return `?resyToken=${booking?.resy_token}`;
  } if (booking?.concierge_resy_token) {
    return `?conciergeResyToken=${booking?.concierge_resy_token}`;
  }
  return '';
};

export const setHash = (hash) => {
  const hashToCompare = window.location.hash.split('?')[0];

  if (hashToCompare !== `#${hash}`) {
    window.location.hash = hash;
  }
};

/* eslint-disable-next-line consistent-return  */
const bookingFlowSideEffects = (state, payload) => {
  const booking = state?.booking?.booking;
  const step = state?.booking?.step;
  switch (step) {
    case BROWSE:
      setHash(`/venues/${payload.venueId}`);
      break;
    case MENU:
      setHash(`/venues/${payload.venueId}/add-ons/${payload.templateId}?`);
      break;
    case SUMMARY:
      setHash('/reservation-details');
      break;
    case RESERVATION_PATH_PLACEMENT:
      setHash('/reservation-path-naa');
      break;
    case CONFIRMATION:
      setHash(`/confirmation${getTokenFromBooking(booking)}`);
      break;
    case AUTH:
      setHash('/login?next=/book');
      break;
    case ADD_CC:
      setHash('/add-payment');
      break;
    case CHOOSE_CC:
      setHash('/credit-card-confirmed');
      break;
    default:
      return null;
  }
};

export default bookingFlowSideEffects;
